<template>
  <div id="app">
    <article>
      <page-navbar v-if="showNav"></page-navbar>
      <!-- 详情页的navbar -->
      <container-navbar v-else></container-navbar>
      <section>
        <router-view></router-view>
      </section>
      <page-footer v-show="showFooter"></page-footer>
    </article>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import PageNavbar from '@/components/page-navbar';
import PageFooter from '@/components/page-footer';
import ContainerNavbar from '@/components/container-navbar';
import sdk from '@/lib/sdk';

import { getURIParam } from '@/utils';

const { mapState, mapMutations } = createNamespacedHelpers('common');

export default {
  name: 'App',
  components: {
    PageNavbar,
    PageFooter,
    ContainerNavbar
  },
  data() {
    return {
      cb: null // 执行回调
    };
  },
  computed: {
    ...mapState(['showFooter', 'isDark', 'showNav', 'source'])
  },
  created() {
    this.getCurSkin();
    this.initFirebase();
  },
  mounted() {
    this.$eventBus.$on('login', cb => {
      this.cb = cb;
      this.handleLogin();
    });
    window.userStateChanged = resStr => {
      const info = sdk.decode(resStr);
      this.setUserInfo(info.result.sid);
      if (info.result.sid && this.cb) {
        this.cb && this.cb();
        this.cb = null;
      }

      // 获取用户ID，初始化firebase
      if (info.result.userid) {
        this.$firebase.setUserId(info.result.userid);
      }
    };
    this.getUserInfo();
    this.getApp();
    this.getSource();
    this.setDragArea();
  },
  methods: {
    ...mapMutations(['setDark', 'setUserInfo', 'setApp', 'setSource']),
    getCurSkin() {
      sdk
        .getCurSkin()
        .then(res => {
          const isDark = res.result == 'dark';
          this.changeMode(isDark);
        })
        .catch(err => console.log(err));
      const isDark = getURIParam('isDark') ? true : false;
      this.changeMode(isDark);
    },
    changeMode(isDark) {
      this.setDark(isDark);
      if (isDark) {
        window.document.documentElement.setAttribute('data-theme', 'dark');
      } else {
        window.document.documentElement.setAttribute('data-theme', 'light');
      }
    },
    handleLogin() {
      sdk.login().catch(err => console.log(err));
    },
    async getUserInfo() {
      sdk
        .getUserInfo()
        .then(res => {
          this.setUserInfo(res.wpssid);
          if (res.userId) {
            this.$firebase.setUserId(res.userId);
          }
        })
        .catch(err => console.log(err));
    },
    getApp() {
      const app = getURIParam('tabname') || 'wps';
      this.setApp(app);
    },
    getSource() {
      const source = getURIParam('source') || 'questionmark';
      this.setSource(source);
    },
    initFirebase() {
      this.$firebase.init();
    },
    /**
     * 容器设置可拖拽区域
     */
    setDragArea() {
      try {
        sdk.setDragArea();
      } catch (e) {
        console.log(e);
      }
    }
  }
};
</script>
<style lang="scss">
@import '@/styles/index.scss';
</style>



// WEBPACK FOOTER //
// src/App.vue